// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e70ded6f","488":"0ea7d31f","977":"d35724d6"}[chunkId] + ".chunk.js";
};